import {
  getSKUparts,
  getProductCategory,
  ProductCategory
} from '@spokeldn/common-sku-functions'
import { CreateReturnProduct, ReturnsProduct } from '../types'

const TOP_CUT: Record<string, string> = {
  Slim: 'SL',
  Straight: 'RG',
  Dadletic: 'DD'
}
const TOP_LENGTH: Record<string, string> = {
  Short: 'SH',
  Regular: 'RG',
  Long: 'LG'
}
const TOP_SIZE: Record<string, string> = {
  XS: 'XS',
  S: 'SS',
  M: 'MM',
  'M+': 'MP',
  L: 'LL',
  'L+': 'LP',
  XL: 'XL',
  XXL: '2X',
  '3XL': '3X'
}
const TOP_JACK_SIZE: Record<string, number> = {
  S: 36,
  M: 38,
  'M+': 39,
  L: 40,
  'L+': 41,
  XL: 42,
  XXL: 44
}

export const mapProductsToReturnedProducts = (
  products: ReturnsProduct[]
): CreateReturnProduct[] => {
  return products.map(product => {
    const exchangeItem: Record<string, unknown> = {}
    let returnReason = 'OTHER'

    if (product.return?.reason && [60, 61].includes(product.return?.reason)) {
      returnReason = 'ITEM_DOES_NOT_FIT'
    }

    if (product.return?.sizes) {
      exchangeItem['sizes'] = product.return.sizes
      exchangeItem['sku'] = getUpdatedSKUWithNewSize(
        product.sku,
        product.return.sizes
      )
    }

    if (product.return?.color) {
      exchangeItem['color'] = {
        title: product.return.color.title,
        image: product.return.color.image,
        productId: product.return.color.product_id.toString()
      }
    }

    return {
      salesItemId: product.sale_item_id,
      reason: returnReason,
      returnReasonId: product.return?.reason,
      returnItemType: product.return?.method.toUpperCase(),
      returnReasonDetail: product.return?.reason_detail || [],
      ...(product.return?.method === 'exchange' && { exchangeItem })
    }
  }) as unknown as CreateReturnProduct[]
}

const getUpdatedSKUWithNewSize = (
  existingSKU: string,
  newSize: Record<string, string>
) => {
  const {
    partialSKU: { type, style, color },
    season
  } = getSKUparts(existingSKU)

  const newSKU = `${type}-${style}-${color}-${season}`

  const category = getProductCategory(existingSKU)
  if (ProductCategory.TROUSERS === category) {
    return `${newSKU}-${newSize.waist}${newSize.build}${newSize.leg}${
      newSize.lowerLeg || '00'
    }`
  }

  if (ProductCategory.SHORTS === category) {
    return `${newSKU}-${newSize.waist}${newSize.build}${
      newSize.leg || newSize.shortsleg || '00'
    }00`
  }

  if (ProductCategory.TOPS === category) {
    return `${newSKU}-${
      TOP_SIZE[newSize.size] || TOP_JACK_SIZE[newSize.size] || ''
    }${TOP_CUT[newSize.cut] || ''}${TOP_LENGTH[newSize.length] || ''}`
  }

  if (ProductCategory.ACCESSORIES === category) {
    return `${newSKU}-${newSize.waist || newSize.size}`
  }
}
